import { Interface } from '@ethersproject/abi'
import { ChainId } from '@hyperjump-defi/sdk'
import V1_EXCHANGE_ABI from './v1_exchange.json'
import V1_FACTORY_ABI from './v1_factory.json'

const V1_FACTORY_ADDRESSES: { [chainId in ChainId]: string } = {
  [ChainId.METIS]: '0xc0a47dFe034B400B47bDaD5FecDa2621de6c4d95',
  [ChainId.FTM_MAINNET]: '0xD3E51Ef092B2845f10401a0159B2B96e8B6c3D30',
  [ChainId.FTM_TESTNET]: '0xD3E51Ef092B2845f10401a0159B2B96e8B6c3D30',
  [ChainId.BSC_MAINNET]: '0x6185A664e90754F4967B9962Fe7B1183b147fc48',
  [ChainId.BSC_TESTNET]: '0xe348b292e8eA5FAB54340656f3D374b259D658b8',
}

const V1_FACTORY_INTERFACE = new Interface(V1_FACTORY_ABI)
const V1_EXCHANGE_INTERFACE = new Interface(V1_EXCHANGE_ABI)

export { V1_FACTORY_ADDRESSES, V1_FACTORY_INTERFACE, V1_FACTORY_ABI, V1_EXCHANGE_INTERFACE, V1_EXCHANGE_ABI }
